import { Injectable } from '@angular/core';
import { Tab } from '../admin/admin-account/admin-account.component';
import { User, claimValue } from '../models';

@Injectable({
	providedIn: 'root',
})
export class AccountTabService {
	apimDefaultTabs: { id: Tab; name: string }[] = [
		{ id: 'overview', name: 'Overview' },
		{ id: 'notes', name: 'Notes' },
	];

	apimProductTabs: { id: Tab; name: string }[] = [
		{ id: 'eDepositApi', name: 'E-Deposit API' },
		{ id: 'screeningApi', name: 'Screening API' },
		{ id: 'cancellationApi', name: 'Cancellation API' },
		{ id: 'checkInHeroApi', name: 'Check In Hero API' },
		{ id: 'screenAndProtectApi', name: 'Screen And Protect API' },
		{ id: 'stayDisruptApi', name: 'Stay Disrupt API' },
	];

	filterApimTabs(user: User, tabs: { id: Tab; name: string }[]): { id: Tab; name: string }[] {
		const productTabsToAdd: Set<{ id: Tab; name: string }> = new Set();
		let isEdepositActive = false;

		user.claims.forEach(claim => {
			// Skip empty values: includes('') matches every tab id.
			const value = claimValue(claim);
			if (!value) return;

			if (value.includes('edeposit') && !isEdepositActive) isEdepositActive = true;

			const tabIndex = this.apimProductTabs.findIndex(x => x.id.toString().toLowerCase().includes(value));
			if (tabIndex > -1) productTabsToAdd.add(this.apimProductTabs[tabIndex]);
		});

		if (!(user.hasApimAccount || isEdepositActive)) return tabs;

		const userTabs = [...this.apimDefaultTabs];
		if (user.hasApimAccount) {
			userTabs.push({ id: 'apimUserSubscriptions', name: 'Subscriptions' });
			userTabs.push({ id: 'apimUserHistory', name: 'History' });
		}
		productTabsToAdd.forEach(tab => userTabs.push(tab));

		return userTabs;
	}
}
